export default function DateTime({ value }) {
  let date

  // Handle Firestore timestamp objects
  if (value && typeof value === 'object' && 'seconds' in value) {
    date = new Date(value.seconds * 1000)
  }
  // Handle ISO strings or other date strings
  else if (typeof value === 'string') {
    date = new Date(value)
  }
  // Handle Date objects directly
  else if (value instanceof Date) {
    date = value
  }
  // Fallback for invalid dates
  else {
    // console.warn("Invalid date value:", value);
    return <span>Just now</span>
  }

  if (isNaN(date.getTime())) {
    console.warn('Invalid date value:', value)
    return <span>Just now</span>
  }

  const formatRelativeDate = (date) => {
    const today = new Date()
    const yesterday = new Date(today)
    yesterday.setDate(yesterday.getDate() - 1)

    // Reset hours, minutes, seconds for comparison
    const todayDate = today.getDate()
    const todayMonth = today.getMonth()
    const todayYear = today.getFullYear()

    const dateDate = date.getDate()
    const dateMonth = date.getMonth()
    const dateYear = date.getFullYear()

    if (
      dateDate === todayDate &&
      dateMonth === todayMonth &&
      dateYear === todayYear
    ) {
      return 'Today'
    } else if (
      dateDate === yesterday.getDate() &&
      dateMonth === yesterday.getMonth() &&
      dateYear === yesterday.getFullYear()
    ) {
      return 'Yesterday'
    } else {
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      })
    }
  }

  return (
    <>
      <span>{formatRelativeDate(date)}</span>{' '}
      <span>
        {date.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        })}
      </span>
    </>
  )
}
